import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAuthData } from '../utils/auth';
import { ROUTES } from '../constants/app';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear authentication data
    clearAuthData();
    
    // Redirect to login page
    navigate(ROUTES.LOGIN);
  }, [navigate]);

  // This component doesn't render anything visible
  // as it immediately redirects after clearing auth data
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px',
      color: '#666'
    }}>
      Logging out...
    </div>
  );
};

export default Logout;
